module.exports = __webpack_public_path__ + "img/drone_06_H.0b8eb581.webp";